import script from "./num.vue?vue&type=script&lang=js"
export * from "./num.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__